<template>
  <div>
    <div class="comment-wrapper">
      <vue-custom-scrollbar class="scroll-area" :settings="settings">
        <div class="parent-comment">
          <template v-for="(comment, index) in comments">
            <!-- contenu-parent-comment -->
            <div
              class="contenu-parent-comment"
              :key="index"
              :id="'comment-' + comment.id"
            >
              <div class="comment-block">
                <div class="date-wrapper">
                  <span class="date">{{ comment.date_modification | moment('DD MMM YYYY HH:mm') }}</span>
                </div>
                <!-- comment-wrap -->
                <div class="comment-wrap" :class="{owner: comment.utilisateur.id === userId}">
                  <!-- top element -->
                  <div class="top-element">
                    <div class="comment-details">
                      <span class="name" v-if="comment.utilisateur.id === userId">Moi</span>
                      <span class="name" v-else>{{
                        `${comment.utilisateur.nom} ${comment.utilisateur.prenom}`
                      }}</span
                      ><span class="name" v-if="comment.utilisateur.invite === 1">(Invité)</span>
                    </div>
                    <div
                      class="action-element"
                      v-if="(modeVue && comment.utilisateur.proprietaire)"
                    >
                      <button
                        class="link-btn"
                        @click.prevent="handleEditCom(comment)"
                      >
                        <font-awesome-icon :icon="['fas', 'edit']" />
                      </button>
                      <button
                        class="delete-btn"
                        @click.prevent="handleDeleteCom(comment.id)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>
                    <div class="action-element" v-if="!modeVue && comment.utilisateur.id === userId">
                      <button
                        class="link-btn"
                        @click.prevent="handleEditCom(comment)"
                      >
                        <font-awesome-icon :icon="['fas', 'edit']" />
                      </button>
                      <button
                        class="delete-btn"
                        @click.prevent="handleDeleteCom(comment.id)"
                      >
                        <font-awesome-icon :icon="['fas', 'trash-alt']" />
                      </button>
                    </div>

                  </div>
                  <!-- top element -->
                  <div class="comment-content">
                    <p v-html="comment.commentaire"></p>
                  </div>
                  <div class="respond">
                    <span @click="handleClickRespond(comment.id)">Répondre</span>
                  </div>
                </div>
                <!-- .comment-wrap -->
                <transition name="fade">
                  <div
                    class="child-comment-wrapper"
                    v-if="comment.reponse.length > 0"
                  >
                    <div class="list-child-comment">
                      <template
                        v-for="(childComment, index) in comment.reponse"
                      >
                        <!-- comment-block child-->
                        <div class="date-wrapper" :key="'reponse-data-' + index">
                          <span class="date">{{ childComment.date_modification | moment('DD MMM YYYY HH:mm') }}</span>
                        </div>

                        <div
                          class="comment-wrap"
                          :key="'reponse-' + index"
                          :id="'comment-' + childComment.id"
                          :class="{ownerchild: childComment.utilisateur.id === userId}"
                        >
                          <div class="top-element">
                            <div class="comment-details">
                              <span class="name" v-if="childComment.utilisateur.id === userId">Moi</span>
                              <span class="name" v-else>{{
                                `${childComment.utilisateur.nom} ${childComment.utilisateur.prenom}`
                              }}</span
                              >
                            </div>
                            <div class="action-element"  v-if="!modeVue && childComment.utilisateur.id === userId || childComment.utilisateur.proprietaire">
                              <button
                                class="link-btn"
                                @click.prevent="handleEditCom(childComment)"
                              >
                                <font-awesome-icon :icon="['fas', 'edit']" />
                              </button>
                              <button
                                class="delete-btn"
                                @click.prevent="handleDeleteCom(childComment.id)"
                              >
                                <font-awesome-icon :icon="['fas', 'trash-alt']" />
                              </button>
                            </div>

                          </div>

                          <div class="comment-content">
                            <p v-html="childComment.commentaire"></p>
                          </div>
                          <div class="respond">
                            <span @click="handleClickRespond(comment.id)">Répondre</span>
                          </div>
                        </div>
                        <!-- .comment-block child-->
                      </template>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <!-- .contenu-parent-comment -->
          </template>
        </div>
      </vue-custom-scrollbar>
    </div>
    <!-- confirmation modal -->
    <b-modal
      id="modal-confirmation"
      title="Confirmation"
      ref="confirmationModal"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      @ok="handleDeleteOk"
      :modal-class="'base-modal'"
      cancel-variant="outline-primary"
      cancel-title="Annuler"
      style="z-index: 2000"
    >
      <p>Êtes-vous certain de vouloir supprimer ce commentaire?</p>
    </b-modal>
    <!-- /confirmation modal -->
  </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    comments: {
      type: Array
    },
    modeVue: {
      type: Boolean,
      default: false
    }
  },
  components: {
    vueCustomScrollbar
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      idComment: null,
      utilisateurInfo: null
    }
  },
  computed: {
    ...mapGetters(['userId'])
  },
  methods: {
    ...mapActions(['setMessage', 'deleteComment']),

    handleClickRespond (id) {
      this.$emit('onRespond', id)
    },
    handleDeleteCom (id) {
      this.idComment = id
      this.$refs.confirmationModal.show()
    },
    async handleDeleteOk () {
      let message = await this.deleteComment({ id: this.idComment, mode: this.modeVue })
      this.setMessage(message)
      this.$emit('deleteOk')
    },
    handleEditCom (comment) {
      this.$emit('editCom', comment)
    }
  }
}
</script>

<style lang="scss">
.comment-wrapper {
  .scroll-area {
    height: calc(100vh - 315px);
    margin-right: -15px;
  }
  .contenu-parent-comment {
    margin-bottom: 15px;
    .img-wrapper {
      margin-top: 25px;
      img {
        object-fit: cover;
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
    .comment-wrap {
      font-family: "Open Sans";
      padding: 5px;
      box-shadow: 0 2px 3px 0 rgba(225, 225, 225, 0.5);
      background-color: #ffffff;
      border-radius: 4px;
      border: 1px solid #2b3085;
      margin-bottom: 10px;
      margin-left: 60px;
      width: 335px;
      position: relative;
      &.owner {
        margin-left: 0;
        margin-right: 60px;
        background-color: #d2d3e5;
      }
      .comment-details {
        color: #2b3085;
        margin-bottom: 5px;
        .name {
          font-size: 12px;
          margin-right: 10px;
        }
        .date {
          font-size: 11px;
          opacity: 0.5;
        }
      }
      .comment-content {
        p {
          margin-bottom: 0;
          font-size: 14px;
          color: #444444;
        }
      }
      .respond {
        color: #2b3085;
        font-size: 13px;
        text-align: right;
        cursor: pointer;
        padding-top: 10px;
        &:hover {
          text-decoration: underline;
        }
      }
      .action-element {

        display: flex;
        button {
          border: none;
          background-color: transparent;
          box-shadow: none;
          color: #2b3085;
          &.link-btn {
            color: #2b3085;
          }
        }

      }
    }
  }
  .child-comment-wrapper {
    // padding-left: 40px;
    position: relative;
    &:before {
      display: none;
      content: "";
      width: 3px;
      position: absolute;
      top: -10px;
      bottom: 0;
      background: linear-gradient(
        180deg,
        rgba(0, 91, 165, 0.5) 0%,
        rgba(0, 91, 165, 0) 100%
      );
    }
    .comment-wrap {
      width: 295px;
      margin-left: 100px;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.date-wrapper {
  text-align: center;
  font-size: 12px;
}

.top-element {
  display: flex;
  justify-content: space-between;
}

.comment-wrapper {

  .comment-wrap {
    &.owner {
       & + .child-comment-wrapper {
         .comment-wrap {
           margin-right: 60px;
           margin-left: 40px;
         }
       }
    }
  }
}

.ownerchild {
  background-color: #d2d3e5 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/voletLaterale/commentsComponents/contenu.vue